import React from "react";
import { Route, Redirect } from "react-router-dom";
import jwt from "jsonwebtoken";

const ProtectedRoute = ({ component: Component, layout: Layout, requiredPermissions, userPermissions, ...rest }) => {
  
  const decodedToken = jwt.decode(sessionStorage.getItem("Clear_AuthUser"));
  var userData;

  const decodedDefaultPasswordChange = jwt.decode(sessionStorage.getItem("GetToChange"));
  const booleanValue = decodedDefaultPasswordChange === 'true';
  
  if (decodedToken != null) {
    userData = JSON.parse(decodedToken.userRolePermissions);
  }

  if (!userData || !requiredPermissions) {
    return <Redirect to="/login" />;
  }

  return (
    <Route
      {...rest}
      render={(props) => {
        if (booleanValue) {
          if (rest.path === "/defaultPasswordChange") {
            return <Component {...props} />;
          } else {
            return <Redirect to="/defaultPasswordChange" />;
          }
        }

        if(!booleanValue){
          if (rest.path === "/defaultPasswordChange") {
            return <Redirect to="/dashboard" />;
          }
          return (
            requiredPermissions.every((permission) => userPermissions[permission]) ? (
              <Layout>
                <Component {...props} />
              </Layout>
            ) : (
              <Redirect to="/dashboard" />
            )
          );
        }
        
      }}
    />
  );
};

export default ProtectedRoute;
